import { ID } from '@datassential/platform-ui-lib';
import { useData } from '@hooks/useData';
import { components } from '@apiSchema';
import http from '@core/fetch';
import apiConfig from '@apiConfig';

export type ConsumerRatingsData = components['schemas']['ConsumerRatingsData'];
export type ConsumerRatingsPreset = components['schemas']['ConsumerRatingsPreset'];

const DEFAULT_DATA: ConsumerRatingsData = {
    presets: [],
    megaAttributes: [],
    strengths: [],
    weaknesses: [],
    chainId: 0,
    defaultPresetId: null,
    nps: 0,
};

const REQUEST_TYPE: keyof typeof apiConfig = 'get consumer ratings';

async function getHomeConsumerRatings(chainId: ID | null): Promise<ConsumerRatingsData> {
    if (chainId == null) return DEFAULT_DATA;

    try {
        return await http.get(REQUEST_TYPE, { chainId: Number(chainId) });
    } catch (err) {
        console.error('Fetch error:', REQUEST_TYPE, err);
        return DEFAULT_DATA;
    }
}

export function useHomeConsumerRatings(chainId: ID | null) {
    return useData(DEFAULT_DATA, getHomeConsumerRatings, chainId);
}
